// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-list {
    border: 1px solid #000;
    padding: 0;
    margin: 0;
    background-color: #fff;
}

.dropdown-list li {
    font-family: Roboto, sans-serif, Tahoma;
    cursor: pointer;
    list-style: none;
    font-size: 16px;
    border-bottom: 1px solid #000;
    padding: 5px;
}

.dropdown-list li:last-child {
    border-bottom: none;
}

.dropdown-list li:hover {
    color: #fff;
    background-color: #1E90FF;
}

.modal-template-wrap {
    box-sizing: border-box;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #8C8C8C;
}

.modal-template-root {
    display: none;
    max-width: 300px;
}

.modal-controls {
    padding-top: 10px;
    display: flex;
    justify-content: space-around;
}

.modal-control-btn {
    cursor: pointer;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    padding: 5px;
    justify-content: center;
    width: calc(100% / 2 - 20px);
    color: #fff;
    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);
    border-radius: 3px;
}

    .modal-control-btn.disabled {
        background: rgb(235, 235, 228);
        color: #000;
    }

.modal-input {
    width: 214px;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
}

.create-window-wrap {
    display: flex;
    flex-direction: column;
}

    .create-window-wrap p {
        font-size: 14px;
        line-height: 14px;
        padding-bottom: 7px;
    }

.upload-wrap {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
}

.modal-select {
    width: 186px;
    height: 24px;
    line-height: 24px;
}

.btn-icon-del {
    cursor: pointer;
}

.modal-group-name {
    color: #1E90FF;
}

.modal-exist-wrap {
    max-width: 250px;
}

.select-wrap {
    display: flex;
    flex-direction: column;
}

.modal-input-upload {
    display: none;
}

.modal-input-upload {
    width: 186px;
    height: 24px;
}

.error-upload {
    color: red;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/controls/trend/kits/kits.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,WAAW;IACX,sGAAsG;IACtG,kBAAkB;AACtB;;IAEI;QACI,8BAA8B;QAC9B,WAAW;IACf;;AAEJ;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;IAEI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;AAEJ;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB","sourcesContent":[".dropdown-list {\r\n    border: 1px solid #000;\r\n    padding: 0;\r\n    margin: 0;\r\n    background-color: #fff;\r\n}\r\n\r\n.dropdown-list li {\r\n    font-family: Roboto, sans-serif, Tahoma;\r\n    cursor: pointer;\r\n    list-style: none;\r\n    font-size: 16px;\r\n    border-bottom: 1px solid #000;\r\n    padding: 5px;\r\n}\r\n\r\n.dropdown-list li:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.dropdown-list li:hover {\r\n    color: #fff;\r\n    background-color: #1E90FF;\r\n}\r\n\r\n.modal-template-wrap {\r\n    box-sizing: border-box;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    border: 1px solid #8C8C8C;\r\n}\r\n\r\n.modal-template-root {\r\n    display: none;\r\n    max-width: 300px;\r\n}\r\n\r\n.modal-controls {\r\n    padding-top: 10px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n.modal-control-btn {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    display: flex;\r\n    padding: 5px;\r\n    justify-content: center;\r\n    width: calc(100% / 2 - 20px);\r\n    color: #fff;\r\n    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);\r\n    border-radius: 3px;\r\n}\r\n\r\n    .modal-control-btn.disabled {\r\n        background: rgb(235, 235, 228);\r\n        color: #000;\r\n    }\r\n\r\n.modal-input {\r\n    width: 214px;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.create-window-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n    .create-window-wrap p {\r\n        font-size: 14px;\r\n        line-height: 14px;\r\n        padding-bottom: 7px;\r\n    }\r\n\r\n.upload-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    align-items: center;\r\n}\r\n\r\n.modal-select {\r\n    width: 186px;\r\n    height: 24px;\r\n    line-height: 24px;\r\n}\r\n\r\n.btn-icon-del {\r\n    cursor: pointer;\r\n}\r\n\r\n.modal-group-name {\r\n    color: #1E90FF;\r\n}\r\n\r\n.modal-exist-wrap {\r\n    max-width: 250px;\r\n}\r\n\r\n.select-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.modal-input-upload {\r\n    display: none;\r\n}\r\n\r\n.modal-input-upload {\r\n    width: 186px;\r\n    height: 24px;\r\n}\r\n\r\n.error-upload {\r\n    color: red;\r\n    font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
